import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { sikestonMOConfig } from "./data";

export default function SikestonMOPage() {
  return <CityPageTemplate config={sikestonMOConfig} />;
}